import { render, staticRenderFns } from "./groupLists.vue?vue&type=template&id=71bec57e&scoped=true&"
import script from "./groupLists.vue?vue&type=script&lang=js&"
export * from "./groupLists.vue?vue&type=script&lang=js&"
import style0 from "./groupLists.vue?vue&type=style&index=0&id=71bec57e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bec57e",
  null
  
)

export default component.exports